import { clientGet, clientPost } from "@/service/client-api/client-api";

export async function updateEcommerceState(
  action: string,
  payload: { type: string; id: string; price: string | number },
) {
  if (action === "delete") {
    await clientPost(
      payload.type === "package"
        ? "ecommerce.cart.packages.remove"
        : "ecommerce.cart.items.remove",
      {
        productVariantId: payload.id,
      },
    );
  }

  if (action === "add") {
    await clientPost(
      payload.type === "package"
        ? "ecommerce.cart.packages.add"
        : "ecommerce.cart.items.add",
      {
        productVariantId: payload.id,
      },
    );
  }
}

export async function getEcommerceValues() {
  const state = await clientGet("ecommerce.cart.items.get");
  const products = state.items;

  return {
    amount: products.length,
    price: parseFloat(state.total),
    products,
    codeApplied: state.promotions && state.promotions.length > 0,
    totalDiscounts: parseFloat(state.totalDiscounts),
    totalTaxes: parseFloat(state.totalTaxes),
    address: state.billingAddress,
    promotions: state.promotions,
    coupon: state.coupon,
    isVoucher: state.isVoucher,
  };
}
